/*
 * @Descripttion:
 * @Author: etong
 * @Date: 2022-06-22 10:16:00
 * @LastEditors: yangtao yangtao@shjinjia.com.cn
 * @LastEditTime: 2024-01-05 11:27:20
 */
// 品牌目标
const map = {
  channelAndManager: () => import('@/views/brandTarget/ChannelAndManager'), // 渠道&负责人
  channelLevel: () => import('@/views/brandTarget/ChannelLevel'), // 渠道等级配置
  brandTargetApproval: () => import('@/views/brandTarget/BrandTargetApproval'), // 品牌目标审批
  createTarget: () => import('@/views/brandTarget/CreateTarget'), // 创建品牌目标审批
  channelTargetList: () => import('@/views/brandTarget/ChannelTargetList'), // 渠道目标列表
  channelTargetDetail: () => import('@/views/brandTarget/ChannelTargetDetail'), // 渠道目标列表
  // channelAndShopTargetSettingList: () => import('@/views/brandTarget/channelAndShopTargetSettingList'), // 渠道组/店铺目标列表
  channelAndShopTargetSetting: () =>
    import('@/views/brandTarget/ChannelAndShopTargetSetting'), // 渠道组/店铺目标配置
  channelAndShopTargetList: () =>
    import('@/views/brandTarget/ChannelAndShopTargetList'), // 店铺/组目标审核页
  targetDetail: () => import('@/views/brandTarget/TargetDetail'), // 品牌目标审批详情
  jdDailyBill: () => import('@/views/brandTarget/JdDailyBill'), // 京东平台日账单
  jdDailyBillDetail: () => import('@/views/brandTarget/JdDailyBillDetail'), // 京东账单明细
  channelReachStatis: () => import('@/views/brandTarget/ChannelReachStatis'), // 渠道达成统计
  brandReachStatis: () => import('@/views/brandTarget/BrandReachStatis'), // 品牌达成统计
  groupReachStatis: () => import('@/views/brandTarget/GroupReachStatis'), // 小组达成统计
  bcstMcnSalesStatistic: () => import('@/views/brandTarget/BcstMcnSalesStatistic'), // MCN广告销售统计
  reachStatisDetail: () => import('@/views/brandTarget/ReachStatisPage'), // 达成统计详情
  // 品牌预算
  promotionBudget: () => import('@/views/brandTarget/PromotionBudget'), // 品牌站外推广预算
  brandBudgetAdjustment: () => import('@/views/brandTarget/BrandBudgetAdjustment'), // 累积预算额度
  brandBudgetCheck: () => import('@/views/brandTarget/BrandBudgetCheck'), // 推广预算审批

  shopAndGroupTargetSettingList: () => import('@/views/brandTarget/ShopAndGroupTargetSettingList'), // 店铺/组目标列表
  shopAndGroupTargetSettingDetail: () => import('@/views/brandTarget/ShopAndGroupTargetSettingDetail'), // 店铺/组目标详情
  goodsSalesStatistics: () => import('@/views/brandTarget/GoodsSalesStatistics'), // 商品销售统计
  goodsSalesStatisticsDetail: () => import('@/views/brandTarget/GoodsSalesStatisticsDetail'), // 商品销售统计详情
  goodsSalesStatisticsForChannelDetail: () => import('@/views/brandTarget/GoodsSalesStatisticsForChannelDetail'),
  groupSalesStatisticsDetail: () => import('@/views/brandTarget/GroupSalesStatisticsDetail'), // 小组销售统计详情
  channelGoodsSalesStatistics: () => import('@/views/brandTarget/GoodsSalesStatisticsForChannelDetail'), // 通过渠道达成统计页面右键=> 详情-商品销售统计
  brandGroupSalesStatisticsDetail: () => import('@/views/brandTarget/BrandGroupSalesStatisticsDetail'), // 品牌达成统计 => 详情渠道达成统计 => 详情-小组达成统计
  apBrandSpendingStatisticsList: () => import('@/views/brandTarget/apSpendingStatisticsList/index'), // A&P品牌花费统计
  apChannelSpendingStatisticsList: () => import('@/views/brandTarget/apSpendingStatisticsList/channel'), // A&P渠道花费统计
  apBrandSpendingStatisticsDetail: () => import('@/views/brandTarget/apSpendingStatisticsDetail/index'), // A&P品牌花费统计详情
  apChannelSpendingStatisticsDetail: () => import('@/views/brandTarget/apSpendingStatisticsDetail/index'), // A&P渠道花费统计详情
  apBrandSpendingDetail: () => import('@/views/brandTarget/apSpendingDetail/index'), // A&P品牌花费详情
  apChannelSpendingDetail: () => import('@/views/brandTarget/apSpendingDetail/index') // A&P渠道花费详情
}

export default map
